import {
  buildStandingLeaderboardItems,
  type StandingLeaderboardEntry,
  type StandingLeaderboardItem,
  type StandingLeaderboardViewer,
} from '@/lib/cpm/buildStandingLeaderboardItems';
import type { ClipperRankFamily } from '@/lib/ranks/types';

export const HALL_STANDING_RADIUS = 3;

export type HallStandingRow = {
  user_id?: string | null;
  name?: string | null;
  avatar_url?: string | null;
  anonymous: boolean;
  views: string;
  video_count: number;
  rank?: number | null;
  title_id?: string | null;
  current_tier_ids?: string[];
  families?: ClipperRankFamily[];
};

export type HallStandingEntry = StandingLeaderboardEntry & {
  title_id?: string | null;
  current_tier_ids: string[];
  families?: ClipperRankFamily[];
};

function toEntry(
  row: HallStandingRow,
  index: number,
  viewerUserId?: string | null,
): HallStandingEntry {
  const rank = row.rank ?? index + 1;
  return {
    user_id: row.user_id ?? null,
    name: row.name ?? null,
    avatar_url: row.avatar_url ?? null,
    anonymous: row.anonymous,
    total_views: row.views,
    video_count: row.video_count,
    views_tier_id: row.current_tier_ids?.[0] ?? null,
    rank,
    is_viewer: Boolean(viewerUserId && row.user_id && row.user_id === viewerUserId),
    title_id: row.title_id ?? null,
    current_tier_ids: row.current_tier_ids ?? [],
    families: row.families,
  };
}

export function buildHallStandingItems({
  rows,
  viewerUserId,
  viewer,
}: {
  rows: HallStandingRow[];
  viewerUserId?: string | null;
  viewer?: StandingLeaderboardViewer | null;
}): StandingLeaderboardItem[] {
  const ranked = (rows || []).map((row, index) => toEntry(row, index, viewerUserId));
  const viewerRank = ranked.find((row) => row.is_viewer)?.rank ?? null;
  const window = viewerRank == null
    ? []
    : ranked.filter((row) => {
      const rank = row.rank ?? 0;
      return rank >= viewerRank - HALL_STANDING_RADIUS
        && rank <= viewerRank + HALL_STANDING_RADIUS;
    });

  return buildStandingLeaderboardItems({
    topEntries: ranked,
    standing: {
      rank: viewerRank,
      total: ranked.length,
      entries: window,
    },
    viewer,
  });
}
